import { createMuiTheme, colors } from '@mui/material';
import shadows from './shadows';
//import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
     // default: '#F4F6F8',#fff
     default:'#fff',
      paper: colors.common.white
    },
    primary: {
      contrastText: '#ffffff',
      main: '#0055B4'
      //'#5664d2'
    },
    secondary: {
      main: '#cccc00',
    },
    text: {
      primary: '#172b4d',
      secondary: '#6b778c'
    }
  },
  shadows,
  //typography
});

export default theme;
